import { format, parseISO } from "date-fns";

export const formatEventDate = (ev) => (ev?.date ? format(parseISO(ev.date), "EEEE, d MMMM yyyy") : "");
export const shortDate = (iso) => (iso ? format(new Date(iso), "d MMM yyyy") : "");
export const dateTime = (iso) => (iso ? format(new Date(iso), "d MMM yyyy, HH:mm") : "");
export const money = (amount, currency = "BSD") =>
  `${currency} ${Number(amount || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const moneyShort = (amount, currency = "BSD") => `${currency} ${Number(amount || 0).toLocaleString("en-US")}`;
export const MODE_LABELS = { in_person: "In-Person", virtual: "Virtual" };
export const humanize = (s) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
export const venueLine = (ev) => [ev?.venue_name, ev?.venue_city].filter(Boolean).join(", ");
export const sortedVisible = (page) =>
  [...(page?.sections || [])].filter((s) => s.visible).sort((a, b) => a.order - b.order);
export const initials = (name) => (name || "").split(" ").map((p) => p[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();
